import { Api } from "../config/request";

export default {
  getTelecallerProfiles(params) {
    return Api.get(`/telecaller/${params}`);
  },
  getTelecaller(id) {
    return Api.get(`/telecaller/edit-telecaller/${id}`);
  },
  updateTelecaller(id, payload) {
    return Api.post(`/telecaller/save-or-update-telecaller/${id}`, payload);
  },
  getClusters() {
    return Api.get("/telecaller/clusters");
  },
};
